import React from 'react'

import { useTranslation } from '@/core/i18n/useTranslation'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/shared/components/atoms/Select'
import { cn } from '@/shared/utils/helpers'

interface LanguageOption {
	value: string
	label: string
	flag: string
}

interface LanguageSelectorProps {
	absolute?: boolean
}

const languages: LanguageOption[] = [
	{ value: 'en', label: 'EN', flag: '🇺🇸' },
	{ value: 'es', label: 'ES', flag: '🇪🇸' },
]

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({
	absolute = true,
}) => {
	const { currentLanguage, changeLanguage } = useTranslation()

	const handleChange = (value: string) => {
		changeLanguage(value)
	}

	const normalizedLanguage = currentLanguage?.split('-')[0] || 'en'
	const currentLang = languages.find(
		(lang) =>
			lang.value === normalizedLanguage || lang.value === currentLanguage
	)

	return (
		<div className={cn(absolute && 'absolute top-4 right-4 z-10')}>
			<Select value={normalizedLanguage} onValueChange={handleChange}>
				<SelectTrigger className="min-w-[100px] h-10 bg-background">
					<SelectValue
						placeholder={
							currentLang
								? `${currentLang.flag} ${currentLang.label}`
								: '🇺🇸 English'
						}
					/>
				</SelectTrigger>
				<SelectContent className="min-w-[120px]">
					{languages.map((lang) => (
						<SelectItem key={lang.value} value={lang.value}>
							<div className="flex items-center gap-2">
								<span className="text-lg">{lang.flag}</span>
								<span>{lang.label}</span>
							</div>
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		</div>
	)
}
